export const blogHeroWrapperStyles = {
	display: 'flex',
	flexDirection: { xs: 'column', md: 'row' },
	height: { xs: '100%', md: 'calc(100vh - 12.5rem)' },
	justifyContent: 'center',
	alignItems: 'flex-start',
	flexShrink: '0',
	overflow: 'hidden',
};

export const mainPhotoWrapperStyles = {
	position: 'relative',
	width: { xs: '100%', md: '66%' },
	height: 'calc(100vh - 12.5rem)',
	flexShrink: '0',
};

export const mainPhotoStyles = { height: '100%' };

export const mainPhotoTextOverlayStyles = {
	position: 'absolute',
	bottom: 0,
	left: 0,
	width: '100%',
	maxHeight: '100%',
	padding: { xs: '1.5rem 1.25rem', md: '2.5rem 10% 2.5rem 2%', lg: '2.5rem 16% 2.5rem 5%' },
	display: 'flex',
	flexDirection: 'column',
	gap: '1.25rem',
	background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.81) 65.1%)',
};
export const mainPhotoRichTextDocProps = {
	color: 'text.light',
	variant: 'bodyXLBook',
	textAlign: 'left',
};
export const buttonStyles = { width: 'fit-content' };

export const remainingPhotosContainerWrapperStyles = (isMobileScreen: boolean) => ({
	display: 'flex',
	flexDirection: { xs: 'row', md: 'column' },
	width: { xs: '100%', md: '34%' },
	height: { xs: '17.813rem', md: 'calc(100vh - 12.5rem)' },
	...(isMobileScreen && {
		alignItems: 'flex-start',
		overflow: 'auto',
		overflowY: 'hidden',
	}),
});
export const smallPhotoWrapperStyles = (isMobileScreen: boolean) => ({
	position: 'relative',
	width: { xs: '14.25rem', sm: '33.33%', md: '100%' },
	height: { xs: '100%', md: '33.33%' },
	...(isMobileScreen && { flexShrink: 0 }),
});
export const smallPhotoTextOverlayStyles = {
	position: 'absolute',
	bottom: 0,
	left: 0,
	width: '100%',
	maxHeight: '100%',
	padding: { xs: '1.5rem 1.25rem 1rem 1.25rem', md: '1.5rem .75rem 1.25rem .75rem' },
	background: 'linear-gradient(180deg, rgba(0, 40, 85, 0.00) 0%, rgba(0, 12, 26, 0.90) 71.35%)',
	color: 'white',
};
export const smallPhotoRichTextDocProps = {
	color: 'text.light',
	variant: 'bodyLargeBook',
	textAlign: 'left',
};
